var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expande-horizontal centraliza"},[_c('span',{staticClass:"grey--text"},[_vm._v("Nada por aqui, atualize para verificar novamente")])])
}]

export { render, staticRenderFns }